<template>
  <div>
    <v-row class="ma-auto" style="width: 70%">
      <v-col cols="12">
        <v-card
          class="d-flex align-center justify-space-between pa-10 pl-16"
          style="
            height: 80px;
            background: linear-gradient(to right, #fff, #dd0e18);
            position: relative;
            overflow: visible;
          "
          ><v-card-title style="margin-left: 100px; color: #dd0e18">User Name</v-card-title>
          <v-icon color="#fff" @click="closeUser">mdi-close</v-icon>
          <h2
            class="d-flex align-center justify-center"
            style="
              font-size: 40px;
              font-weight: 500;
              color: #fff;
              position: absolute;
              top: 20px;
              left: 20px;
              width: 120px;
              height: 120px;
              border-radius: 50%;
              background-color: #dd0e18;
            "
          >
            {{ getInitials(formData.username)}}
          </h2>
        </v-card>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-card class="" style="width: 83%">
          <v-card-title class="" style="font-size: 16px; font-weight: 500">Personal</v-card-title>
          <v-card
            class="mt-10"
            style="width: 300px; background: none; box-shadow: none; margin-left: 30px"
          >
            <label style="font-size: 14px; font-weight: 500; color: #807e7e" for="name"
              >User Name <span style="color: red">*</span></label
            >
            <v-text-field
              id="name"
              v-model="formData.username"
              class="user-input"
              variant="flat"
              placeholder="Your Name"
              density="compact"
              :rules="emailRule"
            ></v-text-field>
            <label style="font-size: 14px; font-weight: 500; color: #807e7e" for="name"
              >Email <span style="color: red">*</span></label
            >
            <v-text-field
              v-model="formData.email"
              class="user-input"
              variant="flat"
              placeholder="Your Email"
              density="compact"
              :rules="passwordRule"
            ></v-text-field>
            <label style="font-size: 14px; font-weight: 500; color: #807e7e" for="name"
              >Mobile<span style="color: red">*</span></label
            >
            <v-text-field
              v-model="formData.mobile"
              class="user-input"
              variant="flat"
              placeholder="Your Mobile Number"
              density="compact"
              :rules="passwordRule"
            ></v-text-field>
            <label style="font-size: 14px; font-weight: 500; color: #807e7e" for="name"
              >First Name<span style="color: red">*</span></label
            >
            <v-text-field
              v-model="formData.first_name"
              class="user-input"
              variant="flat"
              placeholder="Your First Name"
              density="compact"
              :rules="passwordRule"
            ></v-text-field>
            <label style="font-size: 14px; font-weight: 500; color: #807e7e" for="name"
              >Last Name <span style="color: red">*</span></label
            >
            <v-text-field
              v-model="formData.last_name"
              class="user-input"
              variant="flat"
              placeholder="Your Last Name"
              density="compact"
              :rules="passwordRule"
            ></v-text-field>
            <label style="font-size: 14px; font-weight: 500; color: #807e7e" for="name"
              >Department <span style="color: red">*</span></label
            >
            <v-text-field
              v-model="formData.department"
              class="user-input"
              variant="flat"
              density="compact"
              placeholder="Department"
              :rules="passwordRule"
            ></v-text-field>
          </v-card>
          <v-row class="d-flex justify-end align-end pr-10 ga-5 mb-8">
            <v-btn style="background-color: rgba(128, 128, 128, 0.123)" @click="closeUser"> Cancel</v-btn>
            <v-btn style="background-color: #dd0e18; color: #fff">Save</v-btn>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      formData:{}
    };
  },
  created() {
    this.getUserDetails()
  },
  methods: {
    closeUser() {
      this.$router.go(-1);
    },
    getUserDetails(){
    let userDetails = localStorage.getItem("user_details")
      userDetails = JSON.parse(userDetails)
      this.formData=userDetails
  },
  getInitials(name) {
       if (!name) return '';
       let initials = '';
        for (let i = 0; i < name.length; i++) {
          if (name.charAt(i).toUpperCase() === name.charAt(i)) 
          {
           initials += name.charAt(i);
        } 
         }
         return initials;
     },
  },
  
};
</script>

<style scoped>
>>> .user-input .v-field {
  background-color: rgba(128, 128, 128, 0.123);
}
</style>
